(function (w, $, _) {
    
    const assetId = '~/Controls/Site/DetailedCart.min.js';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    const ctx = w.umwAssets[assetId][0];
    const cookie = w.cms && w.cms.cookie ? w.cms.cookie : $.cookie;

    $(function () {
        $('.UC110MainContainer input[data-sync-input],select[data-sync-input]').change(function () {
            const syncInputKey = $(this).data('sync-input');
            if(syncInputKey) {
                const syncInputValue = $(this).val();
                $('.UC110MainContainer input[data-sync-input="' + syncInputKey + '"],select[data-sync-input="' + syncInputKey + '"]').val(syncInputValue);
            }
        });

        if (w.ExternalTrackingEventBus) {
            w.PubSub.subscribe(w.ExternalTrackingEventBus.channel.event.handled,
                function (topic, data) {
                    if (!(data && data.data && data.data.items && data.data.items.length && _.every(data.data.items, function(item) { return item && item.operationSource === 'DetailedCart' }))) {
                        const loc = w.location;
                        w.location = loc.protocol + '//' + loc.host + loc.pathname + loc.search;
                    }
                });
        } else {
            w.PubSub.subscribe('externaltracking.complete',
                function () {
                    const loc = w.location;
                    w.location = loc.protocol + '//' + loc.host + loc.pathname + loc.search;
                });
        }

        $(".js-detailed-cart-collapse-button").on("click", function () {
            const productDetails = $(this).parent().find(".js-detailed-cart-collapsible-content");
            if (productDetails.is(":visible")){
                productDetails.slideUp();
            } else {
                productDetails.slideDown();
            }
        });

        (function setupDeliverabilityByPostCode() {
            var $txbPostalCode = $('#' + ctx.txbPostalCodeId);
            $txbPostalCode.keypress(function (e) {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    var newCode = $txbPostalCode.val().trim();

                    if (!newCode || !newCode.length) {
                        w.PubSub.publish('notification.error',
                            {
                                text: ctx.labels.emptyPostalCode,
                                timeout: 5000
                            });
                    } else if (window.globalSettings.CountryCode === 'NO') {
                        if (newCode.length !== 4 || !$.isNumeric(newCode)) {
                            w.PubSub.publish('notification.error',
                                {
                                    text: ctx.labels.invalidPostalCode,
                                    timeout: 5000
                                });
                        } else {
                            $.getPostalCodeInfo(newCode,
                                function (codeInfo) {
                                    if (codeInfo.valid) {
                                        cookie('PostalCodeOverride', newCode, { path: window.R });
                                        reloadPageAsGet();
                                    } else {
                                        w.PubSub.publish('notification.error',
                                            {
                                                text: ctx.labels.unknownPostalCode,
                                                timeout: 5000
                                            });
                                    }
                                });
                        }
                    } else {
                        cookie('PostalCodeOverride', newCode, { path: window.R });
                        reloadPageAsGet();
                    }
                }
            });

            const $checkoutBtns = $('#' + ctx.btnCheckoutId + ',#' + ctx.lnkKlarnaCheckoutId);
            $checkoutBtns.click(function (e) {
                if ($(this).hasClass('disabledLastBtn')) {
                    e.preventDefault();
                    const $lbPostalCode = $('#' + ctx.lbPostalCodeMissingId);
                    $lbPostalCode.css({ 'visibility': 'visible' });
                    $lbPostalCode.animate({ 'color': 'red' }, 300);
                }
            });

            const $undeliverableProds = $('.' + ctx.undeliverableProductCssClass);
            if ($undeliverableProds.length) {
                $checkoutBtns.addClass('disabledLastBtn');

                $.each($undeliverableProds, function (index, item) {
                    const tempOrderlineId = $(item).data('tolid');
                    if (tempOrderlineId) {
                        $('div[data-tolid="' + tempOrderlineId + '"]').toggleClass(ctx.undeliverableProductCssClass, true);
                    }
                });

                w.PubSub.publish('notification.error',
                    {
                        text: ctx.labels.undeliverableProdsWarning,
                        timeout: 5000
                    });
            }
        })();

        let codes = $('#' + ctx.hDiscountCodesId).val();
        codes = codes ? JSON.parse(codes) : null;
        if (!codes || codes.length === 0) { // if codes exists, free shipping will be called from codes handler
            w.setFreeShippingMessage(ctx.totalPrice);
        }

        if (ctx.cartWarningMessage) {
            w.PubSub.publish('notification.warning', { text: ctx.cartWarningMessage, timeout: 30000 });
        }

        if (ctx.cartErrorMessage) {
            w.PubSub.publish('notification.error', { text: ctx.cartErrorMessage, timeout: 30000 });
        }

        const $btnDeleteAll = $('#' + ctx.btnDeleteAllId);
        if ($btnDeleteAll.length) {
            var isDeleteConfirmed = false;
            var btnDeleteAllName = $btnDeleteAll.attr('id').replace(new RegExp('_', 'g'), '$');

            $btnDeleteAll.on('click',
                function (e) {
                    if (!isDeleteConfirmed) {
                        e.preventDefault();

                        const dialog = "<div class='panel-body'>" + ctx.labels.deleteAllFromCartMsg + "</div>";
                        const $dialog = $(dialog);
                        $dialog.dialog({
                            title: ctx.labels.deleteAllFromCartMsgTitle,
                            resizable: false,
                            modal: true,
                            autoOpen: true,
                            width: 400,
                            buttons: {
                                no: {
                                    text: ctx.labels.no,
                                    class: 'btn btn-link',
                                    click: function () {
                                        isDeleteConfirmed = false;
                                        $(this).dialog('close');
                                    }
                                },
                                yes: {
                                    text: ctx.labels.yes,
                                    autofocus: true,
                                    class: 'btn btn-primary',
                                    click: function () {
                                        $(this).dialog('close');
                                        isDeleteConfirmed = true;
                                        w.__doPostBack(btnDeleteAllName, '');
                                    }
                                }
                            }
                        });
                    }
                });
        }

        if (ctx.isBonusSystemModuleActive) {
            var $bonusStatusPanel = $('.js-bonus-status-init');
            if ($bonusStatusPanel.length) {
                w.require(['bonus/umw.bonus-status.min'],
                    function () {
                        const options = JSON.parse(ctx.bonusInfo);
                        $bonusStatusPanel.bonusstatus(options);
                    });
            }
            var $bonusProgramInfoPanel = $('.js-bonus-program-info');
            if ($bonusProgramInfoPanel.length) {
                w.require(['bonus/umw.bonus-program-info.min'],
                    function() {
                        const options = {
                            bonusProgramInfo: JSON.parse(ctx.bonusProgramInfo),
                            title: ctx.labels.getMoreBonuses,
                        };

                        $bonusProgramInfoPanel.bonusprograminfo(options);
                    });
            }
        }

        _setupVippsHurtigkasse();

        (function setupUploader() {
            let uploader = null;

            if (w.plupload) {
                const $fileUploaderContainer = $('#fileSelectionUploader');
                const $btnRemoveOrderFile = $('#btnRemoveOrderFile');
                const $btnUploadOrderFile = $('#btnUploadOrderFile');
                const $hUploadedFileId = $('input:hidden[id*="hUploadedFileId"]');
                const $fileNameSel = $('span[id*="fileNameSel"]');

                if (!$fileUploaderContainer.length || !ctx.requireFileUpload && !ctx.isFileLoaded) {
                    return;
                }

                if (ctx.isFileLoaded) {
                    $btnRemoveOrderFile.show();
                    $btnUploadOrderFile.hide();
                }

                $btnRemoveOrderFile.click(function (e) {
                    e.preventDefault();

                    if (ctx.isFileLoaded) {
                        $.publicFetch({
                            handler: 'EStoreData',
                            data: {
                                action: 'RemoveCurrentTempOrderFileID'
                            },
                            error: function(msg, type) {
                                if (type !== 'abort') {
                                    w.PubSub.publish('error', msg);
                                    $btnUploadOrderFile.hide();
                                }
                            },
                            complete: function() {
                                $btnUploadOrderFile.show();
                                $btnRemoveOrderFile.hide();
                                $fileNameSel.text(ctx.labels.FileIsNotSelected);
                            }
                        });
                    } else {
                        $btnUploadOrderFile.show();
                        $btnRemoveOrderFile.hide();
                        $fileNameSel.text(ctx.labels.FileIsNotSelected);
                    }
                });

                $fileUploaderContainer.show();

                const uploaderOptions = {
                    browse_button: 'btnUploadOrderFile',
                    url: w.R + 'Startup/Archive/Plupload.ashx?FolderID=' + ctx.uploadFolderId + '&Publish=true&errasjson=1',
                    max_file_size: '160mb',
                    chunk_size: '128kb',
                    multipart: false,
                    multi_selection: false,
                    maxFileCount: 1,
                    flash_swf_url: w.R + 'js/plupload-2.3.6/Moxie.swf',
                    silverlight_xap_url: w.R + 'js/plupload-2.3.6/Moxie.xap'
                };

                const extensions = $btnUploadOrderFile.data('extensions');
                if (extensions) {
                    uploaderOptions.filters = {
                        max_file_size: '160mb',
                        mime_types: [{ title: 'Select files', extensions: extensions }]
                    };
                }
                uploader = new w.plupload.Uploader(uploaderOptions);

                uploader.init();

                uploader.bind('FilesAdded',
                    function (up) {
                        up.start();
                    });

                uploader.bind('Error', function (uploader, err) {
                    if (err && err.message) {
                        w.PubSub.publish('notification.error',
                            {
                                text: err.message,
                                timeout: 5000
                            });
                    }
                });
                uploader.bind('FileUploaded',
                    function (up, file, resp) {
                        if (file.status == window.plupload.DONE) {
                            var err = null;
                            try {
                                err = $.parseJSON(resp.response);
                            } catch (ex) { }
                            if (err && err.error) { //Failure
                                w.PubSub.publish('notification.error',
                                    {
                                        text: err.error,
                                        timeout: 5000
                                    });
                            } else { //Success
                                var newFileItemId = parseInt(resp.response);
                                if (!newFileItemId || isNaN(newFileItemId)) {
                                    newFileItemId = parseInt($(resp.response).text());
                                }
                                $hUploadedFileId.val(newFileItemId);
                                $fileNameSel.text(file.name);
                                $btnUploadOrderFile.hide();
                                $btnRemoveOrderFile.show();
                            }
                        }

                        refreshUploader();
                    });

                refreshUploader();
            }

            function refreshUploader() {
                if (!uploader) { return; }

                uploader.refresh();

                //Fix z-index if html 4
                if (uploader.runtime === 'html4') {
                    $("form[id^='form_']").css('z-index', '999');
                }
            };
        })();

    });

    w.setFreeShippingMessage = function(amount) {
        if (!ctx.showFreeShippingMessage) {
            return;
        }
        
        var $freeShippingMessage = $('.UC110FreeShippingMessage');

        $.ajax({
                url: window.R + 'handlers/public/estoredata.ashx',
                type: 'GET',
                data: {
                    action: 'GetFreeShippingStatus',
                    amount: amount
                },
                dataType: 'json',
            })
            .done(function (result) {
                if (result && result.showNotification) {
                    let freeShippingMessage;
                    if (result.freeShippingRemainder > 0) {
                        freeShippingMessage = ctx.labels.freeShippingMessage.replace('{0}', result.freeShippingRemainderStr);
                    } else {
                        freeShippingMessage = ctx.labels.freeShippingReachedMessage;
                    }
                    $freeShippingMessage.html(freeShippingMessage);
                    $freeShippingMessage.show();
                } else {
                    $freeShippingMessage.hide();
                }
            })
            .fail(function () {
                $freeShippingMessage.hide();
            });
    }

    function reloadPageAsGet() {
        const loc = window.location;
        window.location = loc.protocol + '//' + loc.host + loc.pathname + loc.search;
    }

    w.validateQuantity = function(input) {
        if (isNaN(input.value.replace(/[,.]/g, ''))) {
            input.value = input.defaultValue;
        }
    }

    function _setupVippsHurtigkasse() {
        const isVippsHurtigkasseInitInProgressStorageKey = 'is-vipps-hurtigkasse-init-in-progress';

        const detailedCartContainer = document.getElementById(ctx.mainTableId);
        const vippsHurtigkasseComponent = detailedCartContainer.querySelector('vipps-hurtigkasse');

        if (!vippsHurtigkasseComponent) {
            return;
        }

        const isVippsHurtigkasseInitInProgress = sessionStorage.getItem(isVippsHurtigkasseInitInProgressStorageKey);
        if (isVippsHurtigkasseInitInProgress) {
            sessionStorage.removeItem(isVippsHurtigkasseInitInProgressStorageKey);

            vippsHurtigkasseComponent.startCheckout();
        } else {
            let isFormChanged = false;

            // Listen to the change events in the detailed cart container to remember applying the changes before starting the Vipps Hurtigkasse flow.
            detailedCartContainer.addEventListener('change', function () { isFormChanged = true; });

            // ReSharper disable once Html.EventNotResolved
            vippsHurtigkasseComponent.addEventListener('onbeforestart', function (evt) {
                if (!isFormChanged) {
                    return;
                }

                // Update the changed cart before starting the Vipps Hurtigkasse flow.
                const updateBtn = document.getElementById(ctx.btnUpdateCartId);

                if (updateBtn) {
                    evt.preventDefault();

                    sessionStorage.setItem(isVippsHurtigkasseInitInProgressStorageKey, 'true');

                    updateBtn.click();
                }
            });
        }
    }

})(window, jQuery, _);